export const formatNumber = (number = 0) => {
    return number.toLocaleString('en-US')
}
